import { envConfig } from '@root/env';
import { Delete, Get, Post, Put } from '@/service/request/server';
import { getHeader } from '@/utils/storage';

const baseUrl = envConfig.storageServiceUrl + '/cloud-storage/1.1/schemas/';

function baseApi() {

    function createSchema(className, data, appId) {
        return Post(baseUrl + `${className}`, data, getHeader(appId));
    }

    function querySingleSchema(className, appId) {
        return Get(baseUrl + `${className}`, {}, getHeader(appId));
    }

    function queryAllSchema(appId) {
        return Get(baseUrl, {}, getHeader(appId));
    }

    function deleteSchema(className, appId) {
        return Delete(baseUrl + `${className}`, getHeader(appId));
    }

    function updateSchema(className, data, appId) {
        return Put(baseUrl + `${className}`, data, getHeader(appId));
    }


    return {
        queryAllSchema, querySingleSchema, deleteSchema, createSchema, updateSchema
    };
}

export const storageSchemaApi = baseApi();
